// Central Amden Pulse route configuration — the single place to change the
// canonical marketing URL and the tracked enquiry/booking links. Page content
// itself lives in the CMS (cms_listings, slug "amden-pulse").
import { getEcosystemItems } from './ecosystem';

export const PULSE_ROUTE = '/systems/pulse';
export const PULSE_LISTING_SLUG = 'amden-pulse';

const TRACKING = 'interest=amden-pulse&source=Pulse%20Product%20Page';
export const PULSE_DEMO_HREF = `/contact?${TRACKING}#book-appointment`;
export const PULSE_PRICING_HREF = `/contact?${TRACKING}&topic=pricing#contact-enquiry`;

export const getPulse = () =>
  getEcosystemItems().find((it) => it.slug === PULSE_LISTING_SLUG) || null;
